<script setup lang="ts">
import type { BlokService } from "@/.storyblok/types/120421/storyblok-components";
import { backgroundColorInjectKey } from "../helpers/injectKeys";

defineProps<{
    blok: BlokService;
}>();

const injectedBackgroundColor = inject(backgroundColorInjectKey) as BackgroundColorKey;
</script>

<template>
    <span class="inline-flex items-start" v-editable="blok">
      <Icon
        :name="blok.isInclusive ? 'mdi:check' : 'mdi:close'"
        class="text-brandDark text-2xl sm:text-3xl mr-2 sm:mr-4 flex-shrink-0"
        :class="[
            {'text-brandDark': blok.isInclusive && (injectedBackgroundColor === 'light' || injectedBackgroundColor === 'medium')},
            {'text-brandLight': blok.isInclusive && injectedBackgroundColor === 'dark'},
            {'text-black': !blok.isInclusive}
        ]"
      ></Icon>
      <span :class="{'font-bold': !blok.isInclusive}">{{ blok.text }}</span>
    </span>
</template>